import {SignatureType, useAccountUser} from "@twigsby/client-data";
import {Button, FlexGap, StackHorizontal, useLayout} from "@twigsby/frontend-framework";
import {FormatLocaleDateTime} from "@twigsby/helpers";
import React, {useEffect, useState} from "react";
import {useForwardingBatchProvider} from "../../../Providers/ForwardingBatchProvider";
import {RenderBatchSectionType} from "../../../Types/ForwardingBatchTypes";
import {DrawSignature} from "../Controls/DrawSignature";
import {SelectSignatureForBatchModal} from "../Modals/SelectSignatureForBatchModal";

const BatchSignature = (props: RenderBatchSectionType) => {
    const { currentBatchData, UpdateSignature } = useForwardingBatchProvider();
    const { data } = useAccountUser();
    const { theme } = useLayout();

    const [ currentSignature, setCurrentSignature ] = useState<SignatureType | null | undefined>(currentBatchData?.signature ? currentBatchData?.signature : null);
    const [ drawSignatureOpen, setDrawSignatureOpen ] = useState<boolean>(false);
    const [ digitalSignatureModalOpen, setDigitalSignatureModalOpen ] = useState<boolean>(false);

    const HandleNewSignature = (id: number, base64: string) => {
        setCurrentSignature({ id: id, value: base64 });
        setDrawSignatureOpen(false);
    }

    useEffect(() => {
        if(currentSignature && currentSignature.id !== currentBatchData?.signature?.id) {
            UpdateSignature(currentSignature.id);
        }
    }, [currentSignature])

    if(props.complete) return <BatchSignatureComplete {...props} />;

    return (
        <>
            <div>
                <h5 className={'mb-xs'}>{props.complete ? props.section.name : `Step ${props.sectionIndex}: ${props.section.name}`}</h5>
                <p>I confirm that I, <strong>{data?.name}</strong>, on <strong>{FormatLocaleDateTime(new Date())}</strong>, request that this digital signature is accepted as a legally binding equivalent of my traditional handwritten signature.</p>

                {currentSignature && !drawSignatureOpen && (
                    <img src={currentSignature.value} alt="Selected Signature" style={{filter: theme === 'dark' ? 'invert(1)' : 'none'}}/>
                )}

                {drawSignatureOpen && (
                    <DrawSignature createdCallback={(id: number, base64: string) => HandleNewSignature(id, base64)}/>
                )}

                <StackHorizontal gap={FlexGap.ExtraSmall}>
                    <Button title={'Draw New Signature'} squared={true} onClick={() => setDrawSignatureOpen(true)}
                            disabled={props.readOnly}/>
                    <Button title={'Select from List'} squared={true}
                            onClick={() => setDigitalSignatureModalOpen(true)} disabled={props.readOnly}/>
                </StackHorizontal>
            </div>

            <SelectSignatureForBatchModal
                isOpen={digitalSignatureModalOpen}
                actionedCallback={(newSignature: SignatureType) => setCurrentSignature(newSignature)}
                closeCallback={() => setDigitalSignatureModalOpen(false)}
            />
        </>
    )
}

const BatchSignatureComplete = (props: RenderBatchSectionType) => {
    const { currentBatchData} = useForwardingBatchProvider();
    const { theme } = useLayout();

    return (
        <div>
            <h5 className={'mb-xs'}>{props.complete ? props.section.name : `Step ${props.sectionIndex}: ${props.section.name}`}</h5>

            {currentBatchData?.signature && (
                <img src={currentBatchData?.signature.value} alt="Selected Signature"
                     style={{filter: theme === 'dark' ? 'invert(1)' : 'none'}}/>
            )}
        </div>
    )
}

export { BatchSignature }
